// extracted by mini-css-extract-plugin
export var accountLinks = "DesktopMenu-module--accountLinks--37ccb";
export var active = "DesktopMenu-module--active--13173";
export var activeButton = "DesktopMenu-module--activeButton--f032b";
export var advImgWrapper = "DesktopMenu-module--advImgWrapper--b48a0";
export var arrowButton = "DesktopMenu-module--arrowButton--eba09";
export var avatar = "DesktopMenu-module--avatar--82e44";
export var avatarCircle = "DesktopMenu-module--avatarCircle--0b3c4";
export var btn = "DesktopMenu-module--btn--9907b";
export var cMarginTop = "DesktopMenu-module--c-margin-top--7e09a";
export var cPadding = "DesktopMenu-module--c-padding--c4507";
export var cPaddingBottom = "DesktopMenu-module--c-padding-bottom--5c678";
export var cPaddingTop = "DesktopMenu-module--c-padding-top--9b912";
export var categoryTitle = "DesktopMenu-module--categoryTitle--6ef18";
export var childSvgIcon = "DesktopMenu-module--childSvgIcon--05b53";
export var defaultDropdown = "DesktopMenu-module--defaultDropdown--0c418";
export var desktopNav = "DesktopMenu-module--desktopNav--7d6f4";
export var dropdownItem = "DesktopMenu-module--dropdownItem--fc7d5";
export var fadeIn = "DesktopMenu-module--fadeIn--73a88";
export var growDown = "DesktopMenu-module--growDown--42900";
export var headerLogo = "DesktopMenu-module--headerLogo--afdb2";
export var level1 = "DesktopMenu-module--level1--2b9e6";
export var level2 = "DesktopMenu-module--level2--24787";
export var level3 = "DesktopMenu-module--level3--09ac0";
export var level3Box = "DesktopMenu-module--level3Box--87536";
export var level3Content = "DesktopMenu-module--level3Content--ebf1b";
export var level3Tags = "DesktopMenu-module--level3Tags--31fac";
export var loggedInGroup = "DesktopMenu-module--loggedInGroup--f4cc0";
export var loggedOutGroup = "DesktopMenu-module--loggedOutGroup--231fa";
export var loginBtn = "DesktopMenu-module--loginBtn--58474";
export var logo = "DesktopMenu-module--logo--b07e7";
export var maxWidth = "DesktopMenu-module--max-width--7bdef";
export var megaMenu = "DesktopMenu-module--megaMenu--3f409";
export var megaMenuHeader = "DesktopMenu-module--megaMenuHeader--dfb0e";
export var megaMenus = "DesktopMenu-module--megaMenus--ff067";
export var menuContainer = "DesktopMenu-module--menuContainer--b47b0";
export var menuItem = "DesktopMenu-module--menuItem--56816";
export var menuTitle = "DesktopMenu-module--menuTitle--06571";
export var navigation = "DesktopMenu-module--navigation--a2970";
export var onPrimaryOutline = "DesktopMenu-module--onPrimaryOutline--190fa";
export var open = "DesktopMenu-module--open--12aef";
export var parent = "DesktopMenu-module--parent--ecdd7";
export var parentLink = "DesktopMenu-module--parentLink--4bcb7";
export var parentWrapper = "DesktopMenu-module--parentWrapper--fb0f3";
export var primaryFilled = "DesktopMenu-module--primaryFilled--8bdca";
export var primaryFilledNew = "DesktopMenu-module--primaryFilledNew--ae0de";
export var primaryFilledTwo = "DesktopMenu-module--primaryFilledTwo--294a0";
export var primaryNoStrokeWithIcon = "DesktopMenu-module--primaryNoStrokeWithIcon--6ad40";
export var primaryOutline = "DesktopMenu-module--primaryOutline--be39a";
export var primaryOutlineWithIcon = "DesktopMenu-module--primaryOutlineWithIcon--80708";
export var profileCapsule = "DesktopMenu-module--profileCapsule--6dcfa";
export var profileCapsuleContainer = "DesktopMenu-module--profileCapsuleContainer--68d0d";
export var profileChevron = "DesktopMenu-module--profileChevron--94939";
export var profileDropdown = "DesktopMenu-module--profileDropdown--3a945";
export var pulse = "DesktopMenu-module--pulse--e19c4";
export var quote = "DesktopMenu-module--quote--79734";
export var quote2 = "DesktopMenu-module--quote2--91292";
export var searchIcon = "DesktopMenu-module--searchIcon--7a2c5";
export var searchInput = "DesktopMenu-module--searchInput--6ef92";
export var searchResults = "DesktopMenu-module--searchResults--bf324";
export var searchWrapper = "DesktopMenu-module--searchWrapper--b4857";
export var subTitle = "DesktopMenu-module--subTitle--447ad";
export var svgWrapper = "DesktopMenu-module--svgWrapper--087a1";
export var tagButton = "DesktopMenu-module--tagButton--21e83";
export var title = "DesktopMenu-module--title--98927";
export var whatsappImg = "DesktopMenu-module--whatsappImg--82238";